module.exports = __webpack_public_path__ + "img/网站-15.32b38fa8.jpg";